import _ from 'underscore';
import UI from 'root/ui';
import Cache from 'root/cache';
import Form from 'root/module/form';
import View from 'view/base';

export default View.extend({
    className: 'form-fluid',

    events: {
        'input input[type="text"]' : 'onChange',
        'input textarea'           : 'onChange',
        'click .submit'            : 'onSave',
        'submit form'              : 'onSubmit'
    },

    dom_handlers: {
        onChange: function() {
            this.checkFormChange();
        },

        onSave: function() {
            this.$el.find('form button:submit').click();
        },

        onSubmit: function(e) {
            var form_data = Form.getData(this.$el.find('form'));

            this.$el.find('button.submit').addClass('loading').prop('disabled', true);

            Cache.app.request({
                action: 'portal/updateTranslation',
                data: _.extend(form_data, {
                    portal_id : this.model.id
                }),
                context: this,
                success: function(response) {
                    this.model.set('translation', response);
                    UI.success('Portal translation updated');
                },
                complete: function() {
                    this.$el.find('button.submit').removeClass('loading').prop('disabled', false);
                }
            });
        }
    },

    checkFormChange: function() {
        var form_data = Form.getData(this.$el.find('form'));
        var is_changed = false;

        if (this.model.get('translation')) {
            if (form_data.submit_idea_button            !== this.model.get('translation').submit_idea_button ||
                form_data.new_idea_button               !== this.model.get('translation').new_idea_button ||
                form_data.new_idea_heading              !== this.model.get('translation').new_idea_heading ||
                form_data.new_idea_desc                 !== this.model.get('translation').new_idea_desc ||
                form_data.new_idea_title_placeholder    !== this.model.get('translation').new_idea_title_placeholder ||
                form_data.new_idea_summary_placeholder  !== this.model.get('translation').new_idea_summary_placeholder ||
                form_data.new_idea_thankyou             !== this.model.get('translation').new_idea_thankyou) {

                is_changed = true;
            }
        } else {
            if (form_data.submit_idea_button ||
                form_data.new_idea_button ||
                form_data.new_idea_heading ||
                form_data.new_idea_desc ||
                form_data.new_idea_title_placeholder ||
                form_data.new_idea_summary_placeholder ||
                form_data.new_idea_thankyou) {

                is_changed = true;
            }
        }

        this.$el.find('button.submit').prop('disabled', !is_changed);
    },

    render: function() {
        var content =
        '<div class="field-label">New idea form</div>' +
        '<div class="box box-nopadding">' +
            '<div class="padding-32">' +
                '<form class="form-fluid">' +
                    '<div class="row">' +
                        '<div class="field-label">+ New Idea</div>' +
                        '<input type="text" name="new_idea_button" class="solid medium" maxlength="100" placeholder="New Idea">' +
                    '</div>' +
                    '<div class="row">' +
                        '<div class="field-label">Heading</div>' +
                        '<input type="text" name="new_idea_heading" class="solid medium" maxlength="100" placeholder="Tell us about your idea">' +
                    '</div>' +
                    '<div class="row">' +
                        '<div class="field-label">Description</div>' +
                        '<textarea name="new_idea_desc" class="solid compact" rows="4" placeholder="Please check if a request already exists by using the search function! If you find one, add your vote there instead!"></textarea>' +
                    '</div>' +
                    '<div class="row">' +
                        '<div class="field-label">Title placeholder text</div>' +
                        '<input name="new_idea_title_placeholder" type="text" class="solid medium" maxlength="100" placeholder="Give your idea a title">' +
                    '</div>' +
                    '<div class="row">' +
                        '<div class="field-label">Summary placeholder text</div>' +
                        '<input name="new_idea_summary_placeholder" type="text" class="solid medium" maxlength="100" placeholder="Description: add more details to help us build better products for you to use!">' +
                    '</div>' +
                    '<div class="row">' +
                        '<div class="field-label">Submit Idea</div>' +
                        '<input type="text" name="submit_idea_button" class="solid medium" maxlength="100" placeholder="Submit Idea">' +
                    '</div>' +
                    '<div class="row">' +
                        '<div class="field-label">Thank you message</div>' +
                        '<textarea name="new_idea_thankyou" class="solid compact" rows="4" placeholder="Thank you for submitting your idea!\nOnce your idea is approved, it will appear in the portal."></textarea>' +
                        '<div class="text-info text-small margin-top-4"><i class="fas fa-question-circle"></i> The thank you message is displayed when new ideas require moderation.</div>' +
                    '</div>' +

                    '<button type="submit" class="hidden"></button>' +
                '</form>' +
            '</div>' +
            '<hr class="xsmall">' +
            '<div class="text-align-right padding-32">' +
                '<button type="button" class="primary submit" disabled>Save Changes</button>' +
            '</div>' +
        '</div>';

        this.$el.html(content);

        if (this.model.get('translation')) {
            Form.setData(this.$el.find('form'), this.model.get('translation'));
        }

        return this;
    }
});